import { combineReducers } from "redux";
import loader from "./loader.js";
import analytics from "./analytics.js";
import transcripts from "./transcripts.js";
import user from "./user";
import modal from "./modal.js";
import initiateCall from "./initiateCall.js";

const rootReducer = combineReducers({
  loaderData: loader,
  analyticsData: analytics,
  transcriptsData: transcripts,
  userData: user,
  modalData: modal,
  initiateCall: initiateCall
});

export default rootReducer;
